import { mapGetters } from "vuex";

export default {
    props: {
        slug: {
            type: String,
            required: true
        }
    },
    methods: {
        enumeratedWords(words) {
            return words
                .slice(0, words.length - 1)
                .join(", ")
                .concat(" and ")
                .concat(words[words.length - 1]);
        }
    },
    computed: {
        ...mapGetters("ThesaurusFilter", ["getOriginalThesaurusLength", "getFirst10Synonyms"]),
        thesaurusText() {
            return this.$t("thesaurusDetailPageText", {
                word: this.slug,
                number_of_items: this.getOriginalThesaurusLength,
                first_10_items: this.enumeratedWords(this.getFirst10Synonyms)
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/AnotherWord/AnotherWord.js